export function SpinIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM4.98907 16C4.98907 22.0812 9.91883 27.0109 16 27.0109C22.0812 27.0109 27.0109 22.0812 27.0109 16C27.0109 9.91883 22.0812 4.98907 16 4.98907C9.91883 4.98907 4.98907 9.91883 4.98907 16Z"
        fill="currentColor"
      />
      <path
        d="M29.5055 16C30.8832 16 32.0199 14.8765 31.8059 13.5155C31.6101 12.2694 31.267 11.0479 30.7821 9.87706C29.978 7.93586 28.7994 6.17203 27.3137 4.68629C25.828 3.20055 24.0641 2.022 22.1229 1.21793C20.9521 0.73296 19.7306 0.389945 18.4845 0.194068C17.1235 -0.0198591 16 1.11684 16 2.49454C16 3.87223 17.1308 4.96098 18.4733 5.27044C19.0664 5.40717 19.6487 5.59318 20.2137 5.82723C21.5496 6.38058 22.7634 7.19164 23.7859 8.2141C24.8084 9.23656 25.6194 10.4504 26.1728 11.7863C26.4068 12.3513 26.5928 12.9336 26.7296 13.5267C27.039 14.8692 28.1278 16 29.5055 16Z"
        fill="currentColor"
      />
    </svg>
  );
}
